export enum ThirdPartyAPI {
  TOURPLAN = 'TOURPLAN'
}

export interface OrganizationsRemovedInput {
  organization_providers: OrganizationsProvidersInput;
}

export interface OrganizationsProvidersInput {
  id: number;
  provider_id: number;
  server_id: string;
  server_password: string;
}

export interface OrganizationItem {
  id: number;
  name: string;
  isMapping: boolean;
}
